import * as h from "react";
const l = (e) => /* @__PURE__ */ h.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ h.createElement(
    "mask",
    {
      id: "NU_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ h.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ h.createElement("g", { mask: "url(#NU_svg__a)" }, /* @__PURE__ */ h.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ h.createElement(
    "mask",
    {
      id: "NU_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ h.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ h.createElement("g", { mask: "url(#NU_svg__b)" }, /* @__PURE__ */ h.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ h.createElement(
    "mask",
    {
      id: "NU_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 16
    },
    /* @__PURE__ */ h.createElement("path", { fill: "#fff", d: "M0 0h32v16H0z" })
  ), /* @__PURE__ */ h.createElement("g", { mask: "url(#NU_svg__c)" }, /* @__PURE__ */ h.createElement(
    "path",
    {
      d: "M-2.262 15.13l6.343 1.467 13.521-7.471 1.43-.837 12.844-6.716 3.043-2.12-6.96-.642-11.221 6.33-8.11 3.985-10.89 6.003z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      d: "M-1.705 16.018l3.415 1.12L33.649-.813h-4.795l-30.56 16.832z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      d: "M34.371 14.73l.252 1.51-6.703.357-10.806-6.33-1.02.348L-4.08.411l8.33-1.604L15.386 4.96l8.711 4.21 10.274 5.562z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      d: "M34.395 15.638l-3.415 1.12-13.6-7.687-4.032-.859-16.606-8.75h4.795l16.596 8.543 4.409 1.03 11.852 6.603z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      d: "M13.19-1.25V-2.5h-1.25v1.25h1.25zm0 6V6h1.25V4.75h-1.25zm-14.44 0V3.5H-2.5v1.25h1.25zm0 6.5H-2.5v1.25h1.25v-1.25zm14.44 0h1.25V10h-1.25v1.25zm0 8h-1.25v1.25h1.25v-1.25zm5.688 0v1.25h1.25v-1.25h-1.25zm0-8V10h-1.25v1.25h1.25zm14.372 0v1.25h1.25v-1.25h-1.25zm0-6.5h1.25V3.5h-1.25v1.25zm-14.372 0h-1.25V6h1.25V4.75zm0-6h1.25V-2.5h-1.25v1.25zm-2.5 6V6h1.25V4.75h-1.25zm0-3.5h1.25V0h-1.25v1.25zm-.688 0V0h-1.25v1.25h1.25zm0 3.5h-1.25V6h1.25V4.75zm.688 2.5h1.25V6h-1.25v1.25zm-.688 0V6h-1.25v1.25h1.25zm.688 1.5V10h1.25V8.75h-1.25zm-.688 0h-1.25V10h1.25V8.75zm-2.5-1.5h1.25V6h-1.25v1.25zm-11.94 0V6H0v1.25h1.25zm0 1.5H0V10h1.25V8.75zm11.94 0V10h1.25V8.75h-1.25zm2.5 2.5V10h-1.25v1.25h1.25zm0 5.5h-1.25V18h1.25v-1.25zm.688 0V18h1.25v-1.25h-1.25zm0-5.5h1.25V10h-1.25v1.25zm2.5-4V6h-1.25v1.25h1.25zm0 1.5h-1.25V10h1.25V8.75zm11.872-1.5H32V6h-1.25v1.25zm0 1.5V10H32V8.75h-1.25zM13.19 0h1.25v-2.5h-1.25V0zm1.25 0v-1.25h-2.5V0h2.5zm0 4.75V0h-2.5v4.75h2.5zM0 6h13.19V3.5H0V6zm-1.25 0H0V3.5h-1.25V6zM0 6V4.75h-2.5V6H0zm0 4V6h-2.5v4H0zm0 1.25V10h-2.5v1.25H0zM0 10h-1.25v2.5H0V10zm13.19 0H0v2.5h13.19V10zm1.25 8v-6.75h-2.5V18h2.5zm0 1.25V18h-2.5v1.25h2.5zm0-1.25h-1.25v2.5h1.25V18zm3.188 0H14.44v2.5h3.188V18zm1.25 0h-1.25v2.5h1.25V18zm-1.25 0v1.25h2.5V18h-2.5zm0-6.75V18h2.5v-6.75h-2.5zM32 10H18.878v2.5H32V10zm1.25 0H32v2.5h1.25V10zM32 10v1.25h2.5V10H32zm0-4v4h2.5V6H32zm0-1.25V6h2.5V4.75H32zM32 6h1.25V3.5H32V6zM18.878 6H32V3.5H18.878V6zm-1.25-6v4.75h2.5V0h-2.5zm0-1.25V0h2.5v-1.25h-2.5zm0 1.25h1.25v-2.5h-1.25V0zM14.44 0h3.188v-2.5H14.44V0zm3.188 4.75v-3.5h-2.5v3.5h2.5zM16.378 0h-.688v2.5h.688V0zM14.44 1.25v3.5h2.5v-3.5h-2.5zM15.69 6h.688V3.5h-.688V6zm.688 0h-.688v2.5h.688V6zm1.25 2.75v-1.5h-2.5v1.5h2.5zM15.69 10h.688V7.5h-.688V10zm-1.25-2.75v1.5h2.5v-1.5h-2.5zM13.19 6H1.25v2.5h11.94V6zM0 7.25v1.5h2.5v-1.5H0zM1.25 10h11.94V7.5H1.25V10zm13.19-1.25v-1.5h-2.5v1.5h2.5zm0 2.5v5.5h2.5v-5.5h-2.5zM15.69 18h.688v-2.5h-.688V18zm1.938-1.25v-5.5h-2.5v5.5h2.5zM16.378 10h-.688v2.5h.688V10zm1.25-2.75v1.5h2.5v-1.5h-2.5zM30.75 6H18.878v2.5H30.75V6zM32 8.75v-1.5h-2.5v1.5H32zM18.878 10H30.75V7.5H18.878V10z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.693-1.333H14.31V6H0v4h14.309v9.334h3.384V10H34V6H17.693v-7.333z",
      fill: "#F50100"
    }
  )), /* @__PURE__ */ h.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.049 10.6a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ h.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.1 8.692l-1.298.903.458-1.513L14 7.126l1.58-.032.52-1.493.52 1.493 1.58.032-1.26.956.458 1.513-1.298-.903zM7.1 8.576l-1.082.753.382-1.261-1.05-.797 1.317-.026L7.1 6l.432 1.245 1.318.026-1.05.797.381 1.26L7.1 8.577zM25.1 8.576l-1.082.753.382-1.261-1.05-.797 1.317-.026L25.1 6l.432 1.245 1.318.026-1.05.797.381 1.26-1.081-.752zM16.1 3.776l-1.082.753.382-1.261-1.05-.796 1.317-.027L16.1 1.2l.432 1.245 1.318.027-1.05.796.381 1.26-1.081-.752zM16.1 14.376l-1.082.753.382-1.262-1.05-.796 1.317-.027.433-1.244.432 1.244 1.318.027-1.05.796.381 1.261-1.081-.752z",
      fill: "#FECA00"
    }
  )))
), v = l;
export {
  v as default
};
